import { getStoredQuestion } from './session.question';

/**
 * Check if is visible.
 */
const isVisiblePage = (states) => {
  // Page doesn't have conditions. Mark it as next.
  if (!states || !states.length) {
    return true;
  }
  // If there are conditions, then go through them.
  else {
    stateLoop:
      for (const state of states) {
        // AND logic for questions is ensured by skipping the state,
        // if single question doesn't match condition.
        for (const question of state.questions) {
          let answer = getStoredQuestion(question.aqid);
          // Multi choice questions.
          if (answer && answer.constructor === Array) {
            let matches = 0;
            answer.forEach(value => {
              if (question.answers.includes(value)) {
                matches++;
              }
            });

            // AND match is required.
            if (question.exact && question.answers.length !== matches) {
              continue stateLoop;
            }
            // OR match is required.
            else if (!matches) {
              continue stateLoop;
            }

            // If we got here means conditions matched.
          }
          // Single choice questions.
          else if (!question.answers.includes(answer)) {
            // Since at least one question doesn't have a match,
            // skip the whole state.
            continue stateLoop;
          }

          // All the questions matched for this state.
        }

        // OR logic for state is done by returning TRUE on first that matches
        // condition.
        return true;
      }
  }

  return false;
}

/**
 * Get previous, next and last pages.
 */
const getVisiblePages = (sections, conditions, currentIndex = 0) => {
  let prevPage, nextPage, lastPage;

  // Go through all sections to determine previous and next pages.
  for (let i = 0; i < sections.length; i++) {
    const isVisible = isVisiblePage(conditions ? conditions[i].states : false);

    // Work with visible pages only.
    if (!isVisible) {
      continue;
    }

    // If page can be displayed, determine where it can be used.
    const pageNumber = i + 1;
    // Keep updating prevPage until we reach current page.
    if (i < currentIndex) {
      prevPage = pageNumber;
    }
    // Set next page only once.
    else if (!nextPage && i > currentIndex) {
      nextPage = pageNumber;
    }

    // As long is page is visible, set it as a last page.
    lastPage = pageNumber;
  }

  return {
    prevPage,
    nextPage,
    lastPage
  }
}

export {
  getVisiblePages,
  isVisiblePage
}